import NewCommonServiceHero from "../../../common/NewCommonServices/NewCommonServiceHero";
import NewCommonServiceForm from "../../../common/NewCommonServices/NewCommonServiceForm";
import NewCommonMoreItService from "../../../common/NewCommonServices/NewCommonMoreItService";
import {
  websiteContentIcon,
  seoContentIcon,
  socialMediaContentIcon,
  personalBrandingContentIcon,
  podcastContentICon,
} from "../../../../assets/icons/serviceIcon/index";
import AdCopyWork from "./AdCopyWork";
import { useEffect } from "react";

const items = [
  {
    name: "High-Converting Ad Copywriting",
    text: "Write ad copy that gets attention fast, speaks clearly, and makes people want to click without overpromising or sounding too salesy.",
  },
  {
    name: "Landing Page & Funnel Content",
    text: "Plan and write every section of your funnel to guide people step by step from interest to sign-up or purchase confidently.",
  },
  {
    name: "Funnel Flow Strategy & CTAs",
    text: "Structure your funnel messaging in the right order, with clear CTAs that move people smoothly through every stage of the journey.",
  },
];

const otherService = [
  {
    icon: seoContentIcon,
    name: "Seo Blog Writing",
    des: "Blog posts that teach, tell stories and rank on Google",
    path: "/seo-blog-writing",
  },
  {
    icon: websiteContentIcon,
    name: "Website Content",
    des: "Make your website speak your value in the simplest way",
    path: "/website-content",
  },
  {
    icon: socialMediaContentIcon,
    name: "Social Media Strategy",
    des: "Plan smart, scroll-worthy posts that actually speak to your audience",
    path: "/social-media-strategy",
  },
  {
    icon: personalBrandingContentIcon,
    name: "Personal Branding Content",
    des: "Bring your voice to life across everything your audience sees",
    path: "/personal-branding-content",
  },
  {
    icon: podcastContentICon,
    name: "Podcast Scripting & Editing",
    des: "Turn your ideas into podcasts that engage with your audience",
    path: "/podcast-scripting-and-editing",
  },
];

const AdCopy = () => {

        useEffect(() => {
        // Set Page Title
        document.title = "Ad Copywriting & Sales Funnel Services | TechQilla";
    
        // --- Description ---
        let metaDescription = document.querySelector<HTMLMetaElement>(
          "meta[name='description']",
        );
        if (!metaDescription) {
          metaDescription = document.createElement("meta");
          metaDescription.name = "description";
          document.head.appendChild(metaDescription);
        }
        metaDescription.setAttribute(
          "content",
          "High-converting ad copy and sales funnel strategies that attract, engage, and convert leads into customers with proven frameworks.",
        );
    
        // --- Keywords ---
        let metaKeywords = document.querySelector<HTMLMetaElement>(
          "meta[name='keywords']",
        );
        if (!metaKeywords) {
          metaKeywords = document.createElement("meta");
          metaKeywords.name = "keywords";
          document.head.appendChild(metaKeywords);
        }
        metaKeywords.setAttribute("content", "Ad Copywriting & Sales Funnel Services");
        // --- Canonical ---
        let linkTag = document.querySelector<HTMLLinkElement>(
          "link[rel='canonical']",
        );
        if (!linkTag) {
          linkTag = document.createElement("link");
          linkTag.rel = "canonical";
          document.head.appendChild(linkTag);
        }
        linkTag.setAttribute("href", "https://www.techqilla.com/ad-copy-and-sale-funnels");
        }, []);
  
  return (
    <div className="">
      <NewCommonServiceHero
        colorHeading="Funnels"
        description="We help you say the right thing at the right time so your ads get clicks and your funnels actually convert, without sounding pushy or complicated."
        heading="Ad Copy & Sales"
      />
      <NewCommonServiceForm title="Ad Copy & Sales Funnels" items={items} />
      <AdCopyWork/>
      <NewCommonMoreItService items={otherService} />
    </div>
  );
};

export default AdCopy;
